import { z } from "zod";

export const tagRuleFields = {
  company_domain: "Company domain",
  company_name: "Company name",
  email: "Person email",
  email_domain: "Person email domain",
} as const;
export const tagRuleOperators = {
  equals: "Equals",
  contains: "Contains",
  domain: "Domain and subdomains",
} as const;
export const tagRuleInputSchema = z
  .object({
    tagId: z.uuid(),
    field: z.enum(["company_domain", "company_name", "email", "email_domain"]),
    operator: z.enum(["equals", "contains", "domain"]),
    value: z.string().trim().min(1, "Enter a value to match."),
    enabled: z.boolean(),
  })
  .strict()
  .superRefine((v, ctx) => {
    const domain = v.field.endsWith("domain");
    if (
      (domain && v.operator === "contains") ||
      (!domain && v.operator === "domain") ||
      (v.field === "email" && v.operator !== "equals")
    )
      ctx.addIssue({ code: "custom", message: "Choose a supported matching operator." });
    if (
      domain &&
      !/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(v.value)
    )
      ctx.addIssue({
        code: "custom",
        message: "Enter a domain such as example.com, without a URL or @.",
      });
    if (v.field === "email" && !z.email().safeParse(v.value).success)
      ctx.addIssue({ code: "custom", message: "Enter a complete email address." });
  });
export type TagRuleInput = z.infer<typeof tagRuleInputSchema>;
export type TagRule = TagRuleInput & { id: string; tagName: string; matches: number };
export type TagRulePreview = { total: number; items: { id: string; name: string }[] };
